<template>
  <v-dialog v-model="confirmDialog" max-width="500">
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon class="mr-3 white--text">mdi-information-outline</v-icon>
        {{ $t('shooting.buttons.download.partialDownloadTitle') }}
      </v-card-title>

      <v-card-text class="pa-7 text--primary">
        {{ $t('shooting.buttons.download.partialDownloadText', { optimized: optimizedCount, total: totalCount }) }}
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined rounded @click="closeDialog">{{ $t('common.cancel') }}</v-btn>
        <v-btn color="primary" rounded @click="confirmDownload">{{ $t('shooting.buttons.download.download') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'PartialOptimizedDownloadModal',
  props: {
    dialog: {
      required: true,
      type: Boolean
    },
    optimizedCount: {
      type: Number,
      default: 0
    },
    totalCount: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    confirmDialog: false
  }),
  watch: {
    // Immediate, so a parent that mounts this component with the flag already true still gets
    // an open dialog.
    dialog: {
      immediate: true,
      handler(val) {
        this.confirmDialog = val
      }
    },
    // This dialog is not persistent, so the Escape key and a click outside close it without
    // telling the parent. Report the close, or the parent flag stays true and the dialog never
    // opens again.
    confirmDialog(val) {
      if (!val && this.dialog) this.$emit('close-dialog')
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close-dialog')
    },
    confirmDownload() {
      this.$emit('confirm-download')
    }
  }
}
</script>
